import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import {
  Identifiable,
  Planzone,
  ProjectElementDetailsConfiguration,
} from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  configuration: ProjectElementDetailsConfiguration;
  retrieveProjectElementDetailsConfiguration(
    req: Boundaries["retrieveProjectElementDetailsConfiguration"]["request"],
  ): void;
}

function useRetrieveProjectElementDetailsConfiguration(
  planzone: Identifiable<Planzone>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRetrieveProjectElementDetailsConfigurationRequestPending(
        planzone,
      ),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRetrieveProjectElementDetailsConfigurationRequestSuccess(
        planzone,
      ),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRetrieveProjectElementDetailsConfigurationRequestFailure(
        planzone,
      ),
    ),
    configuration: useSelector(() =>
      selector.getProjectElementDetailsConfiguration(planzone),
    ),
    retrieveProjectElementDetailsConfiguration:
      core.retrieveProjectElementDetailsConfiguration,
  };
}

export { useRetrieveProjectElementDetailsConfiguration };
